module.exports = __webpack_public_path__ + "static/media/tiny.a5ab4341.png";